import axios from 'axios';
import { baseUrl } from '@/config';

export default {
/**
 * 성능/운영 루트 페이지 구성 현황 조쇠
 * @author leesy918
 * @param  {[type]} params [description]
 * @return {[type]}        [description]
 */
  getObjEventInfoForPerf(params) {
    return axios.post(`${baseUrl}/performance/root/get-obj-event-info-for-perf.do`, params);
  },

  /**
 * 성능/운영 루트페이지 구성현황 데이터 조회
 * @author leesy918
 * @return {[type]} [description]
 */
  getObjCountByManagetypeForPerf() {
    return axios.get(`${baseUrl}/performance/root/get-obj-count-by-managetype-for-perf.do`);
  },
  /**
   * 성능/운영 루트에서 작업일정 조회
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getPerfWorkCount(params) {
    return axios.post(`${baseUrl}/performance/root/get-perf-work-count.do`, params);
  },
  /**
   * 선택한 날짜의 등록된 작업 일정 명 / 시퀀스 넘버 / 작업 시간을 조회한다.
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getSelectedDateWorkList(params) {
    return axios.post(`${baseUrl}/performance/root/get-selected-date-work-list.do`, params);
  },
  /**
   * 장비 종류 조회
   * @author leesy918
   * @return {[type]} [description]
   */
  getManageTypeList() {
    return axios.get(`${baseUrl}/performance/root/get-manage-type-list.do`);
  },
  /**
   * 자원 구분 조회
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getSelectRsctypeList(params) {
    return axios.post(`${baseUrl}/performance/root/get-select-rsctype-list.do`, params);
  },
  /**
   * 자원 리스트 조회
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getSelectRscList(params) {
    return axios.post(`${baseUrl}/performance/root/get-select-rsc-list.do`, params);
  },
  /**
   * 선택한 차트의 설정 조회
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getPerfChartSetting(params) {
    return axios.post(`${baseUrl}/performance/root/get-perf-chart-setting.do`, params);
  },

  /**
   * 차트 데이터 조회
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getPerfChartData(params) {
    return axios.post(`${baseUrl}/performance/root/get-perf-chart-data.do`, params);
  },
  /**
   * 테이블 데이터 조회
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getPerfTopCardData(params) {
    return axios.post(`${baseUrl}/performance/root/get-perf-top-card.do`, params);
  },
  /**
   * 루트 페이지 TOP5 차트 자원 설정
   * @author leesy918
   * @param  {[type]} params      [description]
   * @param  {[type]} queryString [description]
   */
  setChartManagementData(params, queryString) {
    return axios.post(`${baseUrl}/performance/root/set-chart-management-data.do?${queryString}`, params);
  },
  /**
   * 선택한 타임라인 이벤트의 상세 정보 조회
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getPerfTimelineInfo(params) {
    return axios.post(`${baseUrl}/performance/root/get-perf-timeline-info.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/performance/root.js